import { apiGuestClient } from "./apiGuestClient";
import { apiClient } from "./apiClient";

export const foLiveCheckinApi = {
  SelectHocSinhAsync: (request: any) => {
    return apiGuestClient.post(`food/live-checkin/select`, request)
    // return apiClient.post(`food/live-checkin/select`, request)
  }
};
